(function () {
  var storageKey = 'collectionGridMode';
  var compactMode = 'compact';
  var largeMode = 'large';
  var updateFrame = null;
  var infiniteScrollFrame = null;
  var infiniteScrollButton = null;
  var infiniteScrollArmed = true;

  function getStoredMode() {
    try {
      return window.localStorage.getItem(storageKey) === largeMode ? largeMode : compactMode;
    } catch (error) {
      return compactMode;
    }
  }

  function updateButtons(mode) {
    document.querySelectorAll('[data-collection-view]').forEach(function (button) {
      var isActive = button.getAttribute('data-collection-view') === mode;
      button.classList.toggle('active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function applyMode(mode) {
    document.querySelectorAll('.collection_template .products-grid-view').forEach(function (grid) {
      grid.classList.toggle('collection-grid--large', mode === largeMode);
      grid.classList.toggle('collection-grid--compact', mode === compactMode);
    });
    updateButtons(mode);
  }

  function saveMode(mode) {
    try {
      window.localStorage.setItem(storageKey, mode);
      window.localStorage.setItem('display', mode === largeMode ? 'grids' : 'grid');
    } catch (error) {
      // The selected mode still works for the current page when storage is unavailable.
    }
  }

  function setMode(mode) {
    var normalizedMode = mode === largeMode ? largeMode : compactMode;
    saveMode(normalizedMode);
    applyMode(normalizedMode);
  }

  function scheduleApply() {
    window.cancelAnimationFrame(updateFrame);
    updateFrame = window.requestAnimationFrame(function () {
      applyMode(getStoredMode());
    });
  }

  function getInfiniteScrollButton() {
    var button = document.querySelector('.infinite-scrolling--auto a.next');
    if (button) return button;

    var productGridContainer = document.querySelector('#ProductGridContainer[data-infinite-scroll="true"]');
    return productGridContainer ? productGridContainer.querySelector('.infinite-scrolling a.next') : null;
  }

  function checkInfiniteScroll(allowLoad) {
    var button = getInfiniteScrollButton();
    if (button !== infiniteScrollButton) {
      infiniteScrollButton = button;
      infiniteScrollArmed = true;
    }
    if (!button || button.getAttribute('aria-busy') === 'true') return;

    var pagination = button.closest('.pagination-wrap') || button;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var paginationTop = pagination.getBoundingClientRect().top;

    if (!infiniteScrollArmed) {
      if (paginationTop > viewportHeight) infiniteScrollArmed = true;
      return;
    }

    if (allowLoad && paginationTop <= viewportHeight) {
      infiniteScrollArmed = false;
      button.click();
    }
  }

  function scheduleInfiniteScroll(allowLoad) {
    window.cancelAnimationFrame(infiniteScrollFrame);
    infiniteScrollFrame = window.requestAnimationFrame(function () {
      checkInfiniteScroll(allowLoad === true);
    });
  }

  function init() {
    var toggle = document.querySelector('[data-collection-view-toggle]');
    if (toggle) {
      document.addEventListener('click', function (event) {
        var button = event.target.closest('[data-collection-view]');
        if (!button) return;
        event.preventDefault();
        setMode(button.getAttribute('data-collection-view'));
      });
    }

    var productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer && 'MutationObserver' in window) {
      new MutationObserver(function () {
        scheduleApply();
        scheduleInfiniteScroll(false);
      }).observe(productGridContainer, {
        childList: true,
        subtree: true
      });
    }

    if (toggle) scheduleApply();
    document.addEventListener('click', function (event) {
      var button = event.target.closest('.infinite-scrolling a.next');
      if (!button) return;
      infiniteScrollButton = button;
      infiniteScrollArmed = false;
    }, true);
    document.addEventListener('scroll', function () {
      scheduleInfiniteScroll(true);
    }, true);
    window.addEventListener('resize', function () {
      scheduleInfiniteScroll(false);
    });
    window.addEventListener('load', function () {
      scheduleInfiniteScroll(false);
    });
    document.addEventListener('shopify:section:load', function () {
      infiniteScrollButton = null;
      infiniteScrollArmed = true;
      scheduleInfiniteScroll(false);
    });
    scheduleInfiniteScroll(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
